import React, { useEffect, useState, type FC } from 'react';
import { getAppNameById } from '@wix/cashier-common/dist/src/utils/getAppNameById';
import { win } from '@wix/cashier-common/dist/src/utils/win';
import { type BaseConfig, type Config } from '../../types/Config';
import { OutboundMessageType } from '../../types/OutboundMessageType';
import { type Translations } from '../../types/Translations';
import { captureException, captureMessage, enrichErrorReports } from '../../utils/errorReporter';
import { emitMessage } from '../../utils/messages/emitMessage';
import { App } from './App';

export interface AppConfigEnhancedProps extends BaseConfig {
  l10n: Translations;
}

export const AppConfigEnhanced: FC<AppConfigEnhancedProps> = (props) => {
  const [config, setConfig] = useState<Config>(null);

  useEffect(() => {
    let isMounted = true;

    emitMessage({ type: OutboundMessageType.GetConfig }, win.parent, props.parentOrigin)
      .catch((error) => {
        const messagePrefix = `Failed to get config from parent frame.`;

        if (error instanceof Error) {
          captureException(error, false, messagePrefix);
        } else {
          // custom ErrorResponse with "message" prop
          captureMessage(`${messagePrefix} ${error?.message || error}`);
        }

        return null;
      })
      .then((theConfig: Config) => {
        if (theConfig && isMounted) {
          enrichErrorReports({
            appId: theConfig.appId,
            mobileAppId: theConfig.biData?.mobileAppId,
            mobileAppVersion: theConfig.biData?.mobileAppVersion,
            country: theConfig.country,
            appName: getAppNameById(theConfig.appId),
            providerId: props.providerId,
            msid: props.msid,
            visitorId: props.visitorId,
            theme: props.theme,
            providerTokenization: String(props.providerTokenization),
            checkoutSessionId: theConfig.checkoutSessionId,
            deviceType: theConfig.deviceType,
            pageType: theConfig.pageType,
          });
          setConfig(theConfig);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  if (!config) {
    return null;
  }

  return <App {...props} {...config} />;
};
